import { render, staticRenderFns } from "./CommodityManage.vue?vue&type=template&id=648f4a49&scoped=true&"
import script from "./CommodityManage.vue?vue&type=script&lang=js&"
export * from "./CommodityManage.vue?vue&type=script&lang=js&"
import style0 from "./CommodityManage.vue?vue&type=style&index=0&id=648f4a49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648f4a49",
  null
  
)

export default component.exports